import React from 'react';

import formatFloatWithSuperscript from '../../core/utils/helpers';

const PriceDetailsItem = ({ name, price, noOfTickets, seat, currency, styleClass }) => (
    <tr className={styleClass}>
        <td>
            {noOfTickets && `${noOfTickets} x `} {name}<br/>
            <span className="text-muted">{seat}</span>
        </td>
        <td className="text-end ">{formatFloatWithSuperscript(price)} {currency}</td>
    </tr>
);
export default PriceDetailsItem;
